"use client";
import { NavigateOptions } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { useParams, useRouter } from "next/navigation";
import { useMemo } from "react";

import ModalManager from "../../../components/Modal/ModalManager";
import { useLocale } from "../contexts/LocaleContext";

export default function useLocalizedRouterServer() {
  const { locale } = useLocale();
  const params = useParams();
  const router = useRouter();
  const corporateCode =
    typeof params?.corporateCode === "string" ? params.corporateCode : undefined;

  const buildPath = useMemo(
    () => (path: string) => {
      const basePath = `/${locale}/${path}`.replaceAll("//", "/");
      if (!corporateCode) return basePath;
      const corporatePrefix = `/${locale}/${corporateCode}`;
      if (
        basePath === corporatePrefix ||
        basePath.startsWith(`${corporatePrefix}/`)
      ) {
        return basePath;
      }
      const remainder = basePath.slice(`/${locale}`.length);
      return `${corporatePrefix}${remainder}`.replaceAll("//", "/");
    },
    [locale, corporateCode]
  );

  return useMemo(
    () => ({
      push(path: string, options?: NavigateOptions) {
        ModalManager.removeAll();
        router.push(buildPath(path), options);
      },
      replace(path: string, options?: NavigateOptions) {
        ModalManager.removeAll();
        router.replace(buildPath(path), options);
      },
      shallow(path: string, type?: "push" | "replace") {
        switch (type) {
          case "push":
            window.history.pushState(null, "", buildPath(path));
            break;
          case "replace":
            window.history.replaceState(null, "", buildPath(path));
            break;
        }
      },
    }),
    [buildPath, router]
  );
}
